import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-community-map',
  templateUrl: './offline-community-map.component.html',
  styleUrls: ['./offline-community-map.component.scss']
})
export class OfflineCommunityMapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
